// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"4656c19f","598":"677a5ee2","703":"5c28013f","787":"fcf06ab1"}[chunkId] + ".chunk.js";
};